export interface Hotspot {
  id: string;
  x: number; // Porcentaje desde la izquierda
  y: number; // Porcentaje desde arriba
  titulo: string;
  descripcion: string;
}

export interface AmbienteDisponible {
  id: number;
  imagenPrincipal: string;
  imagenSecundaria?: string;
  altPrincipal: string;
  altSecundaria?: string;
  hotspots?: Hotspot[]; // Hotspots para la imagen principal
  leyenda?: {
    titulo: string;
    descripcion: string;
    caracteristicas?: string[];
  };
}

export const ambientesDisponibles: AmbienteDisponible[] = [
  {
    id: 1,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente01.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle01.webp',
    altPrincipal: 'Diseño de baño moderno con muebles blancos y grifería premium en Toledo',
    altSecundaria: 'Detalle de acabados de muebles de baño de diseño contemporáneo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 15,
        y: 59,
        titulo: 'Uñero "Pirámide"',
        descripcion: 'negro mate con iluminación LED'
      },
      {
        id: 'hotspot-2',
        x: 30,
        y: 35,
        titulo: 'Marco espejo ovalado',
        descripcion: '1 hueco doble iluminación'
      },
      {
        id: 'hotspot-3',
        x: 13,
        y: 71,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 40,
        y: 71,
        titulo: 'Palillería combinable',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 77,
        y: 38,
        titulo: 'Balda acabado "Roble Natural"',
        descripcion: 'Modelo "Z"'
      },
      {
        id: 'hotspot-6',
        x: 67,
        y: 57,
        titulo: 'Tapa piedra natural "negro marquina"',
        descripcion: 'cantos ingletados'
      }
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Palillería - Roble natural',
        'Mueble - Lacado L-01',
        'Espejo - Roble natural',
        'Lavabo: Resina mineral integrado',
        'Tapa - Negro marquina'
      ]
    }
  },
  {
    id: 2,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente02.webp',
    altPrincipal: 'Muebles de baño minimalista con maderas naturales y diseño funcional',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 28 ,
        titulo: 'Marco espejo',
        descripcion: 'madera rectangular doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 12,
        y: 62,
        titulo: 'Encimera',
        descripcion: 'resina mineral doble seno'
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 78,
        titulo: 'Palillería',
        descripcion: 'combinable fina-gruesa'
      },
      {
        id: 'hotspot-4',
        x: 85,
        y: 71,
        titulo: 'Estructura:',
        descripcion: 'Solapado'
      },
      {
        id: 'hotspot-5',
        x: 85,
        y: 61,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 80,
        y: 35,
        titulo: 'Columna auxiliar',
        descripcion: '1 hueco - 1 puerta'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Palillería - Lacado L-09',
        'Mueble - Roble natural',
        'Espejo y auxiliar - Roble natural',
      ]
    }
  },
  {
    id: 3,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente03.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle03.webp',
    altPrincipal: 'Muebles de baño de lujo con mármol natural y sanitarios de alta gama en Navamuel',
    altSecundaria: 'Muebles de baño - Detalles de acabados premium personalizados',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 29,
        y: 28 ,
        titulo: 'Espejo Modelo "Arcuo"',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 12,
        y: 62,
        titulo: 'Estrucura: ingletada completa',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 62,
        titulo: 'Uñero inglete inferior',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 12,
        y: 53,
        titulo: 'Tapa piedra natural',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 65,
        y: 50,
        titulo: 'Lavabo modelo "Pietra"',
        descripcion: 'piedra natural'
      },
      {
        id: 'hotspot-6',
        x: 65,
        y: 62,
        titulo: 'Palillería combinable fina',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, palillería y espejo - Nogal natural',
        'Tapa y lavabo - Verde india',
      ]
    }
  },
  {
    id: 4,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente04.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle04.webp',
    altPrincipal: 'Muebles de baño clásico con toques de modernidad y materiales de calidad',
    altSecundaria: 'Muebles de baño - Detalle de mueblaje personalizado estilo tradicional',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 29,
        y: 22 ,
        titulo: 'Marco espejo ovalado',
        descripcion: '1 hueco doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 12,
        y: 60,
        titulo: 'Encimera piedra natural',
        descripcion: 'faldon 15 cm, doble seno'
      },
      {
        id: 'hotspot-3',
        x: 52,
        y: 72,
        titulo: 'Palillería combinable fina',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 80,
        y: 35,
        titulo: 'Columna',
        descripcion: '1 puerta - 1 hueco'
      },
      {
        id: 'hotspot-5',
        x: 75,
        y: 64,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Palillería - lacado L-01',
        'Mueble, auxiliar y espejo - Roble azul',
        'Encimera - negro marquina',
      ]
    }
  },
  {
    id: 5,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente05.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle05.webp',
    altPrincipal: 'Muebles de baño contemporáneo con iluminación de diseño y acabados en madera natural',
    altSecundaria: 'Muebles de baño - Detalle de iluminación LED en diseño Navamuel',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 22,
        titulo: 'Luna espejo circular',
        descripcion: 'iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 30,
        y: 54,
        titulo: 'Encimera porcelánica',
        descripcion: 'faldon 10 cm'
      },
      {
        id: 'hotspot-3',
        x: 27,
        y: 62,
        titulo: 'Palillería combinable fina horizontal',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 27,
        y: 70,
        titulo: 'Encimera entamborada',
        descripcion: '5 cm faldon'
      },
      {
        id: 'hotspot-5',
        x: 87,
        y: 63,
        titulo: 'Uñero inglete inferior',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, encimera entamborada y palillería - Etimoe Natural',
        'Encimera - Black Vulcano',
      ]
    }
  },
  {
    id: 6,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente06.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle06.webp',
    altPrincipal: 'Muebles de baño con piedra natural compacta y diseño premium',
    altSecundaria: 'Muebles de baño - Detalle de acabado en piedra compacta de alta durabilidad',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 61,
        y: 22,
        titulo: 'Marco espejo circular',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 40,
        y: 56,
        titulo: 'Palillería fina vertical',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 26,
        y: 61,
        titulo: 'Uñero largo',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 50,
        y: 50,
        titulo: 'Lavabo sobre encimera modelo Kimoa',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 76,
        y: 54,
        titulo: 'Uñero inglete',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Espejo y palillería - roble natural',
        'Mueble lacado L-01',
      ]
    }
  },
  {
    id: 7,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente07.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle07.webp',
    altPrincipal: 'Muebles de baño elegante con revestimientos de porcelánico y diseño personalizado',
    altSecundaria: 'Muebles de baño - Detalle de revestimiento en porcelánico',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 8,
        y: 40,
        titulo: 'Luz led inferior',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 20,
        y: 25,
        titulo: 'Camerino',
        descripcion: '3 puertas'
      },
      {
        id: 'hotspot-3',
        x: 78,
        y: 50,
        titulo: 'Encimera porcelánico',
        descripcion: 'faldon 15 cm doble seno'
      },
      {
        id: 'hotspot-4',
        x: 73,
        y: 63,
        titulo: 'Tirador modelo "Bruno mini"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 20,
        y: 75,
        titulo: 'Enmarcado fino perimetral + ranurado fino',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y camerino - roble pure nature',
        'Encimera - Travertino',
        'Tiradores - Negro cepillas'
      ]
    }
  },
  {
    id: 8,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente08.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle08.webp',
    altPrincipal: 'Muebles de baño con acabados lacados brillantes y diseño vanguardista',
    altSecundaria: 'Muebles de baño - Detalle de acabados lacados de última generación',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 8,
        y: 50,
        titulo: 'Encimera porcelánico',
        descripcion: 'faldon 15 cm doble seno'
      },
      {
        id: 'hotspot-2',
        x: 20,
        y: 15,
        titulo: 'Luna espejo',
        descripcion: 'con iluminación perimetral'
      },
      {
        id: 'hotspot-3',
        x: 20,
        y: 75,
        titulo: 'Apertura push',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 70,
        y: 70,
        titulo: 'Enmarcado fino perimetral',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Encimera - Grey line',
        'Mueble - Roble nórdico'
      ]
    }
  },
  {
    id: 9,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente09.webp',
    altPrincipal: 'Muebles de baño con resinas minerales y diseño futurista en materiales innovadores',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 30,
        y: 20,
        titulo: 'Marco espejo octogonal',
        descripcion: 'iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 65,
        y: 48,
        titulo: 'Lavabo sobre encimera modelo "Bowl"',
        descripcion: 'con iluminación perimetral'
      },
      {
        id: 'hotspot-3',
        x: 65,
        y: 74,
        titulo: 'Tirador modelo "Rita mini"',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Encimera y espejo - roble pure nature',
        'Mueble lacado L-14',
        'Tiradores: oro mate'
      ]
    }
  },
  {
    id: 10,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente10.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle10.webp',
    altPrincipal: 'Muebles de baño con doble lavabo y espejo de marco madera natural',
    altSecundaria: 'Muebles de baño - Detalle de zona de lavabo con accesorios de diseño',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 15,
        y: 20,
        titulo: 'Espejo semi-circular',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 65,
        y: 48,
        titulo: 'Módulos auxiliares',
        descripcion: '2 puertas + hueco central'
      },
      {
        id: 'hotspot-3',
        x: 15,
        y: 64,
        titulo: 'Apertura push',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 48,
        y: 69,
        titulo: 'Estructura ingletada en canto completo',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 48,
        y: 58,
        titulo: 'Tapa resina mineral',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 15,
        y: 53,
        titulo: 'Lavabo sobre encimera modelo "Nico"',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Frentes y espejos - Nogal natural',
        'Estructuras módulos lacado L-02',
        'Tapa: Blanco mate'
      ]
    }
  },
  {
    id: 11,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente11.webp',
    altPrincipal: 'Muebles de baño pequeño optimizado con diseño personalizado en Toledo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 15,
        y: 20,
        titulo: 'Espejo modelo capilla',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 65,
        y: 58,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 18,
        y: 76,
        titulo: 'Estructura tapa + costadas vistas',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Espejo y estructura de mueble - Nogal natural',
        'Frentes lacado L-01',
        'Encimera Blanco mate'
      ]
    }
  },
  {
    id: 12,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente12.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle12.webp',
    altPrincipal: 'Muebles de baño con madera natural de roble y diseño ergonómico',
    altSecundaria: 'Muebles de baño - Detalle de acabado en madera de roble',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 30,
        y: 40,
        titulo: 'Marco espejo modelo gajos',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 15,
        y: 60,
        titulo: 'Uñero inglete',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 15,
        y: 71,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 70,
        y: 57,
        titulo: 'Encimera piedra compacta',
        descripcion: 'lavabo desplazado'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Roble pure nature',
        'Encimera Beige royal',
      ]
    }
  },
  {
    id: 13,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente13.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle13.webp',
    altPrincipal: 'Muebles de baño con madera nogal oscuro y revestimiento de piedra natural',
    altSecundaria: 'Muebles de baño - Detalle en madera nogal con acabados premium',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 60,
        y: 30,
        titulo: 'Espejo modelo "Zeus"',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 35,
        y: 57,
        titulo: 'Estructura remetido completo',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 80,
        y: 59,
        titulo: 'Tirador modelo "Carla mini"',
        descripcion: 'lavabo desplazado'
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 54,
        titulo: 'Lavabo sobre encimera modelo "Quattro"',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble - Mongoy pure nature',
        'Tiradores - Laton cepillado',
        'Lavabos - Blanco mate',
        'Espejo - Oro mate'
      ]
    }
  },
  {
    id: 14,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente14.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle14.webp',
    altPrincipal: 'Muebles de baño con madera ébano y accesorios de baño de lujo',
    altSecundaria: 'Muebles de baño - Detalle de acabado en madera ébano personalizado',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 33,
        y: 18,
        titulo: 'Marco espejo circular',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 35,
        y: 55,
        titulo: 'Encimera',
        descripcion: 'Resina mineral, faldon 15 cm doble seno'
      },
      {
        id: 'hotspot-3',
        x: 60,
        y: 73,
        titulo: 'Apertura push',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Nogal pure nature',
        'Encimera - Blanco mate',
      ]
    }
  },
  {
    id: 15,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente15.webp',
    altPrincipal: 'Muebles de baño moderno con mosaicos cerámicos y diseño minimalista',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25,
        titulo: 'Marco espejo octogonal',
        descripcion: 'con huecos, iluminación frontal'
      },
      {
        id: 'hotspot-2',
        x: 10,
        y: 65,
        titulo: 'Uñero modelo Luna',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 30,
        y: 55,
        titulo: 'Encimera piedra compacta modelo Marino',
        descripcion: 'faldon 25 cm'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Ebano nature',
        'Lavabo - Negro mate',
      ]
    }
  },
  {
    id: 16,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente16.webp',
    altPrincipal: 'Muebles de baño con iluminación cálida y acabados naturales en madera',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25,
        titulo: 'Marco espejo rectangular',
        descripcion: 'iluminación frontal'
      },
      {
        id: 'hotspot-2',
        x: 80,
        y: 50,
        titulo: 'Toallera lateral',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 30,
        y: 50,
        titulo: 'Encimera piedra compacta',
        descripcion: 'faldon 10 cm doble seno'
      },
      {
        id: 'hotspot-4',
        x: 25,
        y: 58,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 35,
        y: 63,
        titulo: 'Estructura semi-ingletada',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Zebrano natural',
        'Encimera - Black gold',
      ]
    }
  },
  {
    id: 17,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente17.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle17.webp',
    altPrincipal: 'Muebles de baño de diseño contemporáneo con muebles lacados y espejo sin marco',
    altSecundaria: 'Muebles de baño - Detalle de acabados en laca brillante',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25,
        titulo: 'Marco espejo circular',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 20,
        y: 54,
        titulo: 'Encimera modelo Marino',
        descripcion: 'faldon 30 cm'
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 58,
        titulo: 'Uñero inglete inferior',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 45,
        y: 61,
        titulo: 'Estructura frente ingletado',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Roble crudo',
        'Encimera - Gris polar',
      ]
    }
  },
  {
    id: 18,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente18.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle18.webp',
    altPrincipal: 'Muebles de baño spa en baño privado con materiales de primera calidad',
    altSecundaria: 'Muebles de baño - Detalle de acabados en piedra compacta de lujo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25,
        titulo: 'Marco espejo circular',
        descripcion: 'doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 90,
        y: 49,
        titulo: 'Tapa ingletada',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 38,
        y: 50,
        titulo: 'Frente "Bisel"',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 55,
        titulo: 'Tirador Modelo "Hugo"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 58,
        y: 45,
        titulo: 'Lavabo sobre encimera modelo "Metal tex"',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, tapa y espejo - Lacado - L-15',
        'Lavabo - Oro rosa',
        'Tirador - Laton cava cepillado'
      ]
    }
  },
  {
    id: 19,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente19.webp',
    altPrincipal: 'Muebles de baño funcional con almacenaje inteligente y diseño práctico en madera',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25,
        titulo: 'Espejo modelo "Eclipse"',
        descripcion: 'iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 90,
        y: 30,
        titulo: 'Balda modelo "Z"',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 33,
        y: 50,
        titulo: 'Lavabo sobre encimera modelo "Quattro"',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 70,
        titulo: 'Frente ranurado fino',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 28,
        y: 56,
        titulo: 'Tirador modelo "rita Maxi"',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 58,
        y: 53,
        titulo: 'Estructura ingletada en canto completa',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y baldas - Lacado - L-11',
        'Lavabo - Blanco mate',
        'Espejo - Oro mate',
        'Tirador - Oro'
      ]
    }
  },
  {
    id: 20,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente20.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle20.webp',
    altPrincipal: 'Muebles de baño con ducha y mampara de cristal en diseño moderno',
    altSecundaria: 'Muebles de baño - Detalle de zona de ducha con accesorios personalizados',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 50,
        y: 53,
        titulo: 'Encimera',
        descripcion: 'faldon 4 cm'
      },
      {
        id: 'hotspot-2',
        x: 70,
        y: 56,
        titulo: 'Frente ranurado ancho',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 30,
        y: 56,
        titulo: 'Tirador modelo "Bruno medium"',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 53,
        titulo: 'Lavabo modelo "Mileto"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 75,
        y: 65,
        titulo: 'Frente enmarcado clásico',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Roble canela',
        'Encimera - Blanco mate',
        'Tirador - Laton cepillado'
      ]
    }
  },
  {
    id: 21,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente21.webp',
    altPrincipal: 'Muebles de baño con bañera integrada en Toledo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 28 ,
        titulo: 'Marco espejo',
        descripcion: 'madera rectangular iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 12,
        y: 52,
        titulo: 'Encimera atamborada',
        descripcion: 'faldon 10 cm'
      },
      {
        id: 'hotspot-3',
        x: 30,
        y: 60,
        titulo: 'Tirador modelo "duron"',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 75,
        y: 61,
        titulo: 'Frente enmarcado clásico + ranurado fino',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 80,
        y: 35,
        titulo: 'Baldas madera a juego',
        descripcion: 'faldon 4 cm'
      },
      {
        id: 'hotspot-6',
        x: 50,
        y: 52,
        titulo: 'Lavabo sobre encimera modelo "Quattro"',
        descripcion: 'faldon 10 cm'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, encimera, espejo y baldas - Roble cambrion',
        'Lavabo - Blanco mate',
        'Tirador - Laton cava cepillado',
      ]
    }
  },
  {
    id: 22,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente22.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle22.webp',
    altPrincipal: 'Muebles de baño con madera roble antiguo y acabados rústicos',
    altSecundaria: 'Muebles de baño - Detalle de acabado vintage en madera roble',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 45,
        y: 20 ,
        titulo: 'Columna a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 58,
        y: 8,
        titulo: 'Marco espejo fordo a medida',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 75,
        y: 80,
        titulo: 'Uñero inglete',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 55,
        y: 65,
        titulo: 'Frente enmarcado clásico',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 80,
        y: 62,
        titulo: 'Tapa de resina mineral',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 55,
        y: 52,
        titulo: 'Lavabo sobre encimera modelo "rajado"',
        descripcion: 'faldon 10 cm'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, espejo y auxiliar - Roble natural',
        'Tapa - Blanco mate',
      ]
    }
  },
  {
    id: 23,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente23.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle23.webp',
    altPrincipal: 'Muebles de baño lujoso con muebles flotantes y revestimiento de mármol natural',
    altSecundaria: 'Muebles de baño - Detalle de mármol natural en muebles flotantes',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 30,
        y: 10 ,
        titulo: 'Marco espejo modelo circular',
        descripcion: 'con huecos, doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 70,
        y: 20,
        titulo: 'Columna a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 15,
        y: 53,
        titulo: 'Tapa ingletada',
        descripcion: 'grosor 4 cm'
      },
      {
        id: 'hotspot-4',
        x: 10,
        y: 70,
        titulo: 'Frente ranurado cuadrado ancho',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 45,
        y: 55,
        titulo: 'Uñero gola',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 30,
        y: 53,
        titulo: 'Lavabo sobre encimera modelo "rajado"',
        descripcion: 'faldon 10 cm'
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Lacado L-13',
        'Lavabo - Blanco mate',
      ]
    }
  },
  {
    id: 24,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente24.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle24.webp',
    altPrincipal: 'Muebles de baño industrial con materiales modernos y acabados metálicos',
    altSecundaria: 'Muebles de baño - Detalle de acabados metálicos estilo industrial',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 10 ,
        titulo: 'Marco espejo madera ovalado',
        descripcion: 'con huecos, doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 75,
        y: 50,
        titulo: 'Lavabo modelo "censa"',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 60,
        titulo: 'Uñero gola',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 10,
        y: 60,
        titulo: 'Tapa ingletada',
        descripcion: 'grosor 4 cm'
      },
      {
        id: 'hotspot-5',
        x: 20,
        y: 75,
        titulo: 'Frentes curvo + rasurado ondulado',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, espejo y encimera - Lacado L-07',
      ]
    }
  },
  {
    id: 25,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente25.webp',
    imagenSecundaria: '/images/ambientes/todos_los_ambientes/detalle25.webp',
    altPrincipal: 'Muebles de baño escandinavo con maderas claras y diseño nórdico minimalista',
    altSecundaria: 'Muebles de baño - Detalle de acabados nórdicos diseño escandinavo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 35,
        y: 25 ,
        titulo: 'Luna espejo modelo "capilla"',
        descripcion: 'iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 10,
        y: 50,
        titulo: 'Lavabo modelo "Ceco"',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 50,
        titulo: 'Uñero pirámide',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 50,
        titulo: 'Tapa ingletada',
        descripcion: 'grosor 19 mm'
      },
      {
        id: 'hotspot-5',
        x: 50,
        y: 65,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, tapa - Mongoy natural',
        'Uñero pirámide - Negro mate'
      ]
    }
  },
  {
    id: 26,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente26.webp',
    altPrincipal: 'Muebles de baño Mediterranean con azulejos de cerámica y tono cálido',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 40,
        y: 25 ,
        titulo: 'Marco espejo madera modelo capilla',
        descripcion: 'con hueco, doble iluminación'
      },
      {
        id: 'hotspot-2',
        x: 50,
        y: 50,
        titulo: 'Lavabo modelo "Round"',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 65,
        titulo: 'Frente ranurado ancho',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 60,
        y: 55,
        titulo: 'Tirador modelo "Araceli"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 75,
        y: 55,
        titulo: 'Tapa resina mineral',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 30,
        y: 72,
        titulo: 'Estructura costados + suelos vistos',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y espejo - Mongoy pure nature',
        'Tapa - Blanco mate',
        'Lavabo - Blanco mate'
      ]
    }
  },
  {
    id: 27,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente27.webp',
    altPrincipal: 'Muebles de baño oriental con revestimientos decorativos y diseño exótico',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 15 ,
        titulo: 'Marco espejo madera',
        descripcion: 'fondo a medida'
      },
      {
        id: 'hotspot-2',
        x: 65,
        y: 25,
        titulo: 'Columnas a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 50,
        titulo: 'Lavabo modelo "Metal Tex"',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 25,
        y: 65,
        titulo: 'Uñero corto',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 40,
        y: 60,
        titulo: 'Frente ranurado cuadrado fino',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 15,
        y: 75,
        titulo: 'Estructura ingletado en canto completo',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, espejo y columnas - Roble crudo',
        'Lavabo - Oro',
      ]
    }
  },
  {
    id: 28,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente28.webp',
    altPrincipal: 'Muebles de baño moderno con sistema de almacenaje vertical personalizado',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 80,
        y: 25 ,
        titulo: 'Luna espejo modelo Eclipse',
        descripcion: 'iluminación perimetral'
      },
      {
        id: 'hotspot-2',
        x: 75,
        y: 70,
        titulo: 'Frente ranurado ancho',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 65,
        y: 50,
        titulo: 'Encimera porcelánica',
        descripcion: 'faldon 12 cm'
      },
      {
        id: 'hotspot-4',
        x: 75,
        y: 50,
        titulo: 'Lavabo modelo "Microplus"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 80,
        y: 67,
        titulo: 'Uñero medio',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 55,
        y: 70,
        titulo: 'Estructura costada + suelos vistos',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y columna - Roble oscurecido',
        'Encimera - Calaccita',
      ]
    }
  },
  {
    id: 29,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente29.webp',
    altPrincipal: 'Muebles de baño con acento de color y diseño contemporáneo',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 20 ,
        titulo: 'Marco espejo ovalado',
        descripcion: 'sin iluminación'
      },
      {
        id: 'hotspot-2',
        x: 10,
        y: 55,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 55,
        titulo: 'Encimera piedra compacta modelo de lavabo Minor',
        descripcion: 'grueso 2 cm'
      },
      {
        id: 'hotspot-4',
        x: 75,
        y: 40,
        titulo: 'Auxiliares con barandilla de cristal a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 80,
        y: 60,
        titulo: 'Tapa piedra compacta',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 10,
        y: 67,
        titulo: 'Estructura costada vistas',
        descripcion: ''
      },
      {
        id: 'hotspot-7',
        x: 70,
        y: 65,
        titulo: 'Frente ranurado combinado cancha-fina',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble, espejos y auxiliares - Roble abedul',
        'Encimera - Super white',
      ]
    }
  },
  {
    id: 30,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente30.webp',
    altPrincipal: 'Muebles de baño zen con elementos naturales y acabados relajantes en madera',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 25 ,
        titulo: 'Espejo modelo Reus',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 80,
        y: 30,
        titulo: 'Columna con puerta corredera a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 55,
        titulo: 'Tapa de resina mineral',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 25,
        y: 55,
        titulo: 'Lavabo modelo "Quattro"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 20,
        y: 70,
        titulo: 'Apertura push',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 50,
        y: 70,
        titulo: 'Frente ranura ondulada',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y columna - Lacado L-12',
        'Lavabo - Azul prusia',
        'Tapa - Blanco mate',
        'Espejo - Oro'
      ]
    }
  },
  {
    id: 31,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente31.webp',
    altPrincipal: 'Muebles de baño luxury con accesorios de oro y acabados brillantes',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 20,
        y: 15 ,
        titulo: 'Luna espejo ovalado',
        descripcion: 'sin iluminación'
      },
      {
        id: 'hotspot-2',
        x: 50,
        y: 55,
        titulo: 'Encimera atamborada',
        descripcion: 'faldon 10 cm'
      },
      {
        id: 'hotspot-3',
        x: 50,
        y: 71,
        titulo: 'Uñero inglete superior',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 50,
        y: 80,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y encimera - Roble tone',
      ]
    }
  },
  {
    id: 32,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente32.webp',
    altPrincipal: 'Muebles de baño contemporáneo con porcelánico imitación madera y diseño limpio',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 35 ,
        titulo: 'Luna espejo rectangular',
        descripcion: 'con luz perimetral'
      },
      {
        id: 'hotspot-2',
        x: 30,
        y: 65,
        titulo: 'Lavabo modelo "Quattro"',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 75,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 50,
        y: 75,
        titulo: 'Uñero inglete inferior',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 50,
        y: 35,
        titulo: 'Modulo abierto con estantes',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 70,
        y: 35,
        titulo: 'Columna a juego',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y columna - Roble azul',
        'Lavabo - Blanco mate'
      ]
    }
  },
  {
    id: 33,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente33.webp',
    altPrincipal: 'Muebles de baño con resina de color y acabados brillantes innovadores',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 25,
        y: 20 ,
        titulo: 'Luna espejo rectangular',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 20,
        y: 50,
        titulo: 'Encimera atamborada',
        descripcion: 'faldon 10 cm'
      },
      {
        id: 'hotspot-3',
        x: 25,
        y: 75,
        titulo: 'Estructura ingletada',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 75,
        y: 55,
        titulo: 'Uñero inglete inferior',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Encimera y mueble - Roble tuno'
      ]
    }
  },
  {
    id: 34,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente34.webp',
    altPrincipal: 'Muebles de baño ecológico con materiales sostenibles y maderas naturales certificadas',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 50,
        y: 20 ,
        titulo: 'Luna espejo rectangular',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 75,
        y: 40,
        titulo: 'Baldas',
        descripcion: 'grosor 4 cm'
      },
      {
        id: 'hotspot-3',
        x: 40,
        y: 55,
        titulo: 'Encimera resina mineral con angulo',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 50,
        y: 55,
        titulo: 'Lavabo modelo "Mileto"',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 50,
        y: 75,
        titulo: 'Apertura push',
        descripcion: ''
      },
      {
        id: 'hotspot-6',
        x: 65,
        y: 80,
        titulo: 'Estructura remetido completo',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Frente y baldas - Lacado L-02',
        'Estructura mueble - Lacado L-01',
        'Encimera - Blanco mate'
      ]
    }
  },
  {
    id: 35,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente35.webp',
    altPrincipal: 'Muebles de baño art deco con líneas geométricas y acabados dorados',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 30,
        y: 25 ,
        titulo: 'Columna a juego',
        descripcion: ''
      },
      {
        id: 'hotspot-2',
        x: 70,
        y: 30,
        titulo: 'Lunas espejo rectangulares',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 75,
        y: 75,
        titulo: 'Estructura remetido completo',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 65,
        y: 75,
        titulo: 'Apertura push',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble y columna - Roble vintage natural',
      ]
    }
  },
  {
    id: 36,
    imagenPrincipal: '/images/ambientes/todos_los_ambientes/ambiente36.webp',
    altPrincipal: 'Muebles de baño moderno de Navamuel con diseño y revestimientos premium',
    hotspots: [
      {
        id: 'hotspot-1',
        x: 80,
        y: 20 ,
        titulo: 'Luna espejo ovalada',
        descripcion: 'sin iluminación'
      },
      {
        id: 'hotspot-2',
        x: 80,
        y: 55,
        titulo: 'Encimera de porcelana',
        descripcion: ''
      },
      {
        id: 'hotspot-3',
        x: 80,
        y: 75,
        titulo: 'Uñero gola',
        descripcion: ''
      },
      {
        id: 'hotspot-4',
        x: 75,
        y: 85,
        titulo: 'Estructura costados vistos',
        descripcion: ''
      },
      {
        id: 'hotspot-5',
        x: 85,
        y: 90,
        titulo: 'Patas metálicas',
        descripcion: ''
      },
    ],
    leyenda: {
      titulo: 'Acabados',
      descripcion: '',
      caracteristicas: [
        'Mueble lacado - L-08',
        'Detalles interiores - Lacado L-01',
        'Patas - Inox',
        'Encimera - Blanco Brillo'
      ]
    }
  },
];
